// eslint-disable-next-line no-unused-vars
import React, { useEffect } from "react";
import Heading from "../../components/Highlightedheading/Heading";
import SubCategoryItem from "./SubCategoryItem";
import Pageheading from "../../components/PageHeading/Pageheading";

import { RiHome2Line } from "react-icons/ri";
import Aos from "aos";
import Thumbnail from "../../components/Thumbnail/Page";

const SubCategoryPage = ({ headingText, pageHeading, data }) => {
  //628

  useEffect(() => {
    Aos.init({
      easing: "ease-in",
      duration: 1500,
      once: false,
    });
  }, []);

  return (
    <div className="w-full h-full  text-white">
      <div className="relative w-full h-[50vh] md:h-[72.8vh] flex items-center overflow-hidden">
        <div className="absolute inset-0  "></div>
        <div
          className="absolute inset-0 bg-cover bg-no-repeat bg-center flex justify-center items-center"
          style={{ backgroundImage: `url(/Upcoming_img/up_bg.png)` }}
        >
          {/* <Heading headingText={headingText} className="flex items-center justify-center flex-wrap w-[50%]" /> */}
          <Heading
            headingText={headingText}
            className={" flex flex-wrap  text-center leading-none"}
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent z-10 h-[93dvh]">
          <div className="md:pl-[5.63vw] pl-[3vw] flex items-center md:pt-[21vh] pt-[14vh]">
            <Pageheading
              pageHeading={pageHeading}
              icon={<RiHome2Line />}
              className={" "}
            />
          </div>
        </div>
      </div>

      <div className="w-full items-center mx-auto md:py-[5vw] py-[8vw] flex justify-center">
        <div
          className="grid grid-cols-1 md:max-w-[70%] relative lg:grid-cols-4 md:gap-[1.04vw] px-4 md:px-0 gap-[3.77vw] place-items-center"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-offset="150"
        >
          {data.map((item, index) => (
            <div key={index}>
              <Thumbnail item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubCategoryPage;
